import React from "react";
import "./style.css";
import CENModal from "../CENModal/CENModal";
import { useSelector } from "react-redux";
import filterIcon from "../../assets/filter-icons.svg";
import { Link } from "react-router-dom";

function DashBoardFiltersUi({
  cenData,
  filtersId,
  applyFilter,
  removeFilter,
  decodedToken,
  showFilter,
  isFilter,
  setIsFilter,
  setFiltersId,
  setShowModal,
  showModal,
  setCenSearch,
  cenSearch,
  selectedCEN,
}) {
  const handleRemoveFilter = (key) => {
    setFiltersId({ ...filtersId, cen_id: "" }); // Clear the filter value
    applyFilter();
    setIsFilter(true);
    // removeFilter(updatedFilters); // Call the remove filter method
  };
  const getLabelFromId = (key, id) => {
    if (key === "cen_id" && id) {
      const stateData = cenData?.find((val) => val?.id == id);
      return stateData ? `${stateData?.name}` : id;
    }
    return id; // Fallback for unhandled cases
  };
  const renderAppliedFilters = () => {
    const appliedFilters = Object.entries(filtersId).filter(
      ([key, value]) => value !== "" && value !== undefined
    );

    return appliedFilters?.map(([key, value]) => (
      <div>
        <button
          type="button"
          className="btn btn-secondary rounded-5 px-2 ml-2 h-30px f-12px"
          onClick={() => handleRemoveFilter(key)}
        >
          {getLabelFromId(key, value)} <i className="fa fa-times f-12px"></i>
        </button>
      </div>
    ));
  };
  return (
    <div className="filter-main-container">
      {/* <h5 className="mb-2 filter-heading">Filters</h5>   */}
      {selectedCEN ? (
        <div
          className="d-flex align-items-center cursor-pointer"
          onClick={() => setShowModal(true)}
          style={{ width: "fit-content" }}
        >
          <h5 className="mb-0 filter-heading cursor-pointer">
            {selectedCEN?.name}{" "}
          </h5>
          {/* <i className="mt-1 ml-2 fas fa-hashtag"></i> */}
          <img src={filterIcon} alt="icons" className="filter-icon" />
        </div>
      ) : (
        null
      )}
      {showFilter?.cen && (
        <div className="row">
          <div className="col-12">
            <div className="card-body">
              <div className="dashboard-filter">
                <div>
                  <div className="card-body">
                    <div className="mb-2">
                      <div className="row">
                        {showFilter?.cen && (
                          <div className="col-10">
                            <div>
                              <div class="form-group">
                                <label
                                  htmlFor="select"
                                  className=" dash_filters_label"
                                >
                                  CEN
                                </label>
                                <div>
                                  <select
                                    id="cenId"
                                    name="cenId"
                                    value={filtersId?.cen_id}
                                    className="form-control w-100 p-2 select_css select2bs4"
                                    style={{ width: "100%" }}
                                  >
                                    <option value="">All CEN</option>
                                    {cenData?.map((val) => {
                                      const id = val?.id;
                                      return (
                                        <option value={id}>{val.name}</option>
                                      );
                                    })}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* {showFilter?.rrb && decodedToken?.role == 3 && (
                        <div className="col-3">
                          <div>
                            <div class="form-group">
                              <label
                                htmlFor="select"
                                className=" dash_filters_label"
                              >
                                RRB
                              </label>
                              <div>
                                <select
                                  id="rrb_id"
                                  name="rrb_id"
                                  className="form-control w-100 p-2 select_css select2bs4"
                                  style={{ width: "100%" }}
                                  value={filtersId?.rrbId}
                                >
                                  <option value="">All RRBs</option>
                                  {selectData?.rrb?.map((val) => {
                                    const id = val?.id;
                                    return (
                                      <option value={id}>{val.name}</option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {showFilter?.state && (
                        <div className="col-3">
                          <div>
                            <div class="form-group">
                              <label
                                htmlFor="select"
                                className=" dash_filters_label"
                              >
                                State
                              </label>
                              <div>
                                <select
                                  id="state_id"
                                  name="state_id"
                                  value={filtersId?.stateId}
                                  className="form-control w-100 p-2 select_css select2bs4"
                                  style={{ width: "100%" }}
                                >
                                  <option value="">All States</option>
                                  {selectData?.states?.map((val) => {
                                    const id = val?.id;
                                    return (
                                      <option value={id}>{val.name}</option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {showFilter?.city && (
                        <div className="col-3">
                          <div>
                            <div class="form-group">
                              <label
                                htmlFor="select"
                                className=" dash_filters_label"
                              >
                                City
                              </label>
                              <div>
                                <select
                                  id="city_id"
                                  name="city_id"
                                  value={filtersId?.cityId}
                                  className="form-control w-100 p-2 select_css select2bs4"
                                  style={{ width: "100%" }}
                                >
                                  <option value="">All Cities</option>
                                  {selectData?.city?.map((val) => {
                                    const id = val?.id;
                                    return (
                                      <option value={id}>{val.name}</option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {showFilter?.center && (
                        <div className="col-3">
                          <div>
                            <div class="form-group">
                              <label
                                htmlFor="select"
                                className=" dash_filters_label"
                              >
                                Center
                              </label>
                              <div>
                                <select
                                  id="centre_id"
                                  name="centre_id"
                                  value={filtersId?.centre_id}
                                  className="form-control w-100 p-2 select_css select2bs4"
                                  style={{ width: "100%" }}
                                >
                                  <option value="">All Centers</option>
                                  {selectData?.centre?.map((val) => {
                                    const id = val?.id;
                                    return (
                                      <option value={id}>{val.name}</option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      )} */}
                        {/* {decodedToken?.role == 3 ? ( */}
                        <>
                          {/* <div className="col-3">
                            <div className="form-group mb-0">
                              <label className=" dash_filters_label">
                                Date range
                              </label>
                              <div className="input-group">
                                <input
                                  type="text"
                                  className="form-control float-left"
                                  id="filter_date_reservation"
                                  name="dateRange" // Update the name to match Formik's state
                                />
                                <div className="input-group-prepend ">
                                  <span className="input-group-text calender-icon-custom-border-radius">
                                    <i className="far fa-calendar-alt" />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div> */}
                          {!showFilter?.button ? null : (
                            <div className="col-2 mt-4">
                              <div className="d-flex">
                                <button
                                  className="dash_filters_clear_btn"
                                  onClick={() => {
                                    removeFilter();
                                    setIsFilter(false);
                                  }}
                                >
                                  Clear
                                </button>

                                <button
                                  className="dash_filters_apply_btn ml-3"
                                  onClick={() => {
                                    applyFilter();
                                    setIsFilter(true);
                                  }}
                                >
                                  Apply
                                </button>
                              </div>
                              {/* {isFilter && (
                        <div className="mt-1">
                          <p className="text-danger mb-0">Filter Applied</p>
                        </div>
                      )} */}
                            </div>
                          )}
                        </>
                        {/* ) : (
                        <div className="col-6">
                          <div className="row ">
                            <div className="col-7">
                              <div className="form-group mb-0">
                                <label className=" dash_filters_label">
                                  Date range
                                </label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control float-left"
                                    id="filter_date_reservation"
                                    name="dateRange" // Update the name to match Formik's state
                                  />
                                  <div className="input-group-prepend ">
                                    <span className="input-group-text calender-icon-custom-border-radius">
                                      <i className="far fa-calendar-alt" />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-4 mt-3">
                              <div
                                className="d-flex "
                                style={{ marginTop: "26px" }}
                              >
                                <button
                                  className="dash_filters_clear_btn"
                                  onClick={() => {
                                    removeFilter();
                                    setIsFilter(false);
                                  }}
                                >
                                  Clear
                                </button>

                                <button
                                  className="dash_filters_apply_btn ml-3"
                                  onClick={() => {
                                    applyFilter();
                                    setIsFilter(true);
                                  }}
                                >
                                  Apply
                                </button>
                              </div>
                              {isFilter && (
                          <div className="mt-1">
                            <p className="text-danger mb-0">Filter Applied</p>
                          </div>
                        )}
                            </div>
                          </div>
                        </div>
                      )} */}
                      </div>
                      <div className="d-flex align-items-center mt-3">
                        {/* <h6>Applied Filters:</h6> */}
                        {renderAppliedFilters()}
                      </div>
                      {/* <div className="d-flex align-items-center mt-1">
                      <h6>Applied Filters:</h6>
                      <div>
                        <button
                          type="button"
                          className="btn btn-secondary rounded-5 px-2 ml-2 h-30px f-12px"
                        >
                          Option 1 <i className="fa fa-times f-12px"></i>
                        </button>
                      </div>
                    </div> */}
                      {/* <div className="d-flex mt-3">
                    
                        <button
                          className="dash_filters_clear_btn"
                          onClick={() => {
                            removeFilter();
                            setIsFilter(false);
                          }}
                        >
                          Clear
                        </button>
                   
                        <button
                          className="dash_filters_apply_btn ml-3"
                          onClick={() => {
                            applyFilter();
                            setIsFilter(true);
                          }}
                        >
                          Apply
                        </button>
                    
                      {isFilter && (
                        <div className="col-2 ">
                          <p className="text-danger mb-0">Filter Applied</p>
                        </div>
                      )}
                    </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal ? (
        <CENModal
          data={cenData}
          setShowModal={setShowModal}
          setCenSearch={setCenSearch}
          cenSearch={cenSearch}
          setFiltersId={setFiltersId}
          filtersId={filtersId}
        />
      ) : null}
    </div>
  );
}

export default DashBoardFiltersUi;
